






































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Folder, FolderId, WallId } from 'types'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzTextButton from 'library/v4/components/OzTextButton.vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from 'library/v4/components/OzContainedButton.vue'
import OzScreenSizeAwareCenterModal from 'library/v4/components/OzScreenSizeAwareCenterModal.vue'
import OzScreenSizeAwarePopoverModal from 'library/v4/components/OzScreenSizeAwarePopoverModal.vue'
import OzMenuRows, {
  OzMenuRowsRow,
  OzMenuRowsRowStyle,
  OzMenuRowsFocusStyle,
} from 'library/v4/components/OzMenuRows.vue'

const browser = namespace('browser')

@Component({
  components: {
    OzIcon,
    OzMenuRows,
    OzTextButton,
    OzContainedButton,
    OzScreenSizeAwareCenterModal,
    OzScreenSizeAwarePopoverModal,
  },
})
export default class BookmarksModal extends Mixins() {
  OzContainedButtonColorScheme = OzContainedButtonColorScheme
  OzContainedButtonSizePreset = OzContainedButtonSizePreset
  OzMenuRowsFocusStyle = OzMenuRowsFocusStyle
  OzMenuRowsRowStyle = OzMenuRowsRowStyle

  isTitleFrozen = false
  isBookmarkedInitially = false

  @browser.Getter windowWidth!: number
  @browser.Getter windowHeight!: number
  @browser.Getter isSmallerThanTabletPortrait!: boolean

  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Wall ID.
   */
  @Prop({ required: true }) wallId!: WallId

  /**
   * List of folders.
   */
  @Prop({ required: true }) folders!: Folder[]

  /**
   * IDs for folders that the wall is contained in.
   */
  @Prop({ required: true }) bookmarkedFolderIds!: FolderId[]

  /**
   * Is it in the favorites folder?
   */
  @Prop({ required: true }) isFavorite!: boolean

  /**
   * Modal will be centered if no anchor is provided.
   */
  @Prop({ required: false, default: null }) popoverAnchor

  get folderRows(): OzMenuRowsRow[] {
    return this.folders.map((folder: Folder) => ({
      text: folder.name,
      rightIcon: this.isWallInFolder(folder) ? 'checkmark_thicker' : null,
      rightIconSize: 20,
      rightIconHighlighted: true,
      eventPayload: folder,
    }))
  }

  get folderIdSet(): Set<FolderId> {
    return new Set(this.bookmarkedFolderIds)
  }

  get isBookmarked(): boolean {
    return this.isFavorite || this.bookmarkedFolderIds.length > 0
  }

  @Watch('isBookmarked', { immediate: true })
  detectIsBookmarkedInitially(): void {
    if (!this.isTitleFrozen) this.isBookmarkedInitially = this.isBookmarked
  }

  isWallInFolder(folder): boolean {
    return this.folderIdSet.has(folder.id)
  }

  toggleFavoritesBookmark(): void {
    this.isTitleFrozen = true
    const options = { wallId: this.wallId }
    try {
      if (this.isFavorite) {
        this.$emit('remove-bookmark', options)
      } else {
        this.$emit('add-bookmark', options)
      }
    } catch (e) {
      this.$emit('error', e)
    }
  }

  toggleFolderBookmark(folder: Folder): void {
    this.isTitleFrozen = true
    const options = { wallId: this.wallId, folderId: folder.id }
    try {
      if (this.isWallInFolder(folder)) {
        this.$emit('remove-bookmark', options)
      } else {
        this.$emit('add-bookmark', options)
      }
    } catch (e) {
      this.$emit('error', e)
    }
  }

  clearAllBookmarks(): void {
    this.isTitleFrozen = true
    const wallId = this.wallId
    try {
      if (this.isFavorite) this.$emit('remove-bookmark', { wallId })
      this.folders.forEach((folder: Folder) => {
        if (this.isWallInFolder(folder)) this.$emit('remove-bookmark', { wallId, folderId: folder.id })
      })
    } catch (e) {
      this.$emit('error', e)
    }
  }

  newFolder(event): void {
    this.isTitleFrozen = true
    this.$emit('new-folder', event)
  }

  close(event): void {
    this.$emit('close', event)
  }
}
